/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import BenefitsTable from './components/BenefitsTable';

const Benefits = ({ history }) => (
  <div className="benefits container">
    <Card>
      <CardBody>
        <h2><strong>Beneficios</strong></h2>
        <BenefitsTable history={history} />
      </CardBody>
    </Card>
  </div>
);

Benefits.propTypes = {
  history: PropTypes.object.isRequired,
};

export default Benefits;
